import { render, staticRenderFns } from "./NormalNewsList.vue?vue&type=template&id=6fbb1e20&scoped=true&"
import script from "./NormalNewsList.vue?vue&type=script&lang=js&"
export * from "./NormalNewsList.vue?vue&type=script&lang=js&"
import style0 from "./NormalNewsList.vue?vue&type=style&index=0&id=6fbb1e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb1e20",
  null
  
)

export default component.exports